import moment, { Moment } from "moment";

interface YearSelectProps {
  value: Moment;
  onChange: (date: Moment, year: number) => void;
  futureOnly?: boolean;
}

const YearSelect = ({ value, onChange, futureOnly = false }: YearSelectProps) => (
  <select
    value={value.year()}
    onChange={e => {
      onChange(value, parseInt(e.target.value));
    }}
  >
    {futureOnly
      ? new Array(51).fill(0).map((_, i) => {
          const yr = moment().year() + i;
          return (
            <option key={yr} value={yr}>
              {yr}
            </option>
          );
        })
      : new Array(100).fill(0).map((_, i) => {
          const yr = moment().year() - i;
          return (
            <option key={yr} value={yr}>
              {yr}
            </option>
          );
        })}
  </select>
);

export default YearSelect;
